import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const QuizService = sdk.getService('QuizService');

export const useGetAvailableQuizModesForStudent = () => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['quizzes', 'available-modes-for-student'],
    queryFn: () => QuizService.getAvailableQuizModesForStudent(),
    refetchOnMount: true
  });

  return {
    availableQuizModes: data,
    isLoading,
    error
  };
};
